import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

const animatedComponents = makeAnimated();

const initial_value = {
  services: [],
  reworks: [],
  charges: [],
};

export default function ModalInvoice(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [payment_types, SetPaymentTypes] = useState([]);
  const [save_data, SetSaveData] = useState(initial_value);
  const [read_only, SetReadOnly] = useState(false);
  const [service_data, SetServiceData] = useState([]);
  const [charge_data, SetChargeData] = useState([]);
  const [init_data, SetInitData] = useState([]);
  const [selected, SetSelected] = useState("");

  useEffect(() => {
    console.log("ModalInvoice On mount :", props);
    let myModal1 = document.getElementById("ModalInvoice");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("close_data :", close_data);
      SetReadOnly(false);
      SetSaveData({
        services: [],
        reworks: [],
        charges: [],
      });
      SetSelected("");
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalInvoice On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ModalInvoice"),
        {}
      );
      if (props.type == "add") {
        get_invoice_init();
      }

      if (props.type == "view") {
        SetReadOnly(true);
        SetSaveData((prevValue) => {
          //   prevValue.amount = props.data.amount;
          //   prevValue.selected_payment = {
          //     label: props.data.payment_type,
          //     value: 0,
          //   };
          //   prevValue.notes = props.data.notes;
          return { ...prevValue };
        });
      }
      myModal.show();
    }
  }, [props.open]);

  async function get_invoice_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
    };
    let data = await api("/outlet/create_order_invoice_init", pass_data);
    console.log("create_order_invoice_init response :", data);
    let set_value = {};
    Object.keys(data.response).map((ele, index) => {
      if (index == 0) {
        SetSelected(ele);
      }
      if (ele != "auth") {
        set_value[ele] = data.response[ele];
      }
    });
    console.log("set_value :", set_value);
    SetInitData(set_value);
    if (data.response.hasOwnProperty("services")) {
      SetServiceData(data.response.services);
    }
    if (data.response.hasOwnProperty("charges")) {
      SetChargeData(data.response.charges);
    }
    // if (data.response.hasOwnProperty("total_amount")) {
    //   data.response.payment_types.map((ele, index) => {
    //     ele.label = ele.name;
    //     ele.value = ele.id;
    //   });
    //   SetPaymentTypes(data.response.payment_types);
    // }
  }

  async function create_invoice() {
    console.log("create receipt :", save_data);

    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: save_data,
    };
    console.log("pass_data:", pass_data);
    let data = await api("/outlet/create_order_invoice", pass_data);
    console.log("create_order_invoice response :", data.response);
    if (data.response.hasOwnProperty("invoices")) {
      let item = close_data;
      item.action = "get_invoice";
      console.log("Close data : ", item);
      SetCloseData(item);
      SetSaveData(initial_value);
      SetSelected("");
      myModal.hide();
    }
  }

  function title_generate(title: any) {
    let replaced_data = title.replaceAll("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  return (
    <div
      className="modal fade"
      id="ModalInvoice"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" id="ModalLabel">
              {props.type == "add" ? <h5>Add Invoice</h5> : null}
              {props.type == "view" ? <h5>View Invoice</h5> : null}
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            {props.type == "add" ? (
              <div className="g-3 m-3 ">
                <div className="row">
                  {Object.keys(init_data).map((ele, index) => (
                    <div
                      className="col-md-4 col-6 pb-2"
                      key={index}
                      onClick={() => {
                        console.log("ele :", ele);
                        SetSelected(ele);
                        //   console.log("init_data :", init_data[ele]);
                      }}
                    >
                      <div
                        className={
                          selected == ele
                            ? "withActive cursor"
                            : "withoutActive cursor"
                        }
                      >
                        <div className="row text-center align-items-center">
                          <p className="d-sm-none d-md-block mb-0">
                            {title_generate(ele)}
                          </p>
                          <p className="v-small d-sm-block d-md-none mb-0">
                            {title_generate(ele)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="pt-2 ">
                  <div className="">
                    {selected != "" ? (
                      <div
                        // className="accordion mt-3"
                        // className="m-3"
                        id={"accordion" + selected}
                      >
                        {Object.keys(service_data).length > 0
                          ? init_data[selected].map((ele, ele_index) => (
                            <div className="" key={ele_index}>
                              <div
                                // className="accordion-header"
                                // id={"heading" + selected + ele_index}
                              >
                                <div className="mt-2 ">
                                  <div className="row py-3 bg-light">
                                    <label className="d-flex">
                                      <input
                                        type="checkbox"
                                        name="service"
                                        checked={
                                          ele.invoiced ||
                                          save_data[selected].some(
                                            (s) => s == ele.id
                                          )
                                        }
                                        disabled={
                                          selected == "services"
                                            ? ele.invoiced
                                              ? true
                                              : ele.finished
                                                ? false
                                                : true
                                            : false
                                        }
                                        onChange={(e) => {
                                          SetSaveData((prevValue) => {
                                            if (e.target.checked) {
                                              prevValue[selected].push(
                                                ele.id
                                              );
                                            } else {
                                              let index = prevValue[
                                                selected
                                              ].findIndex((i) => i == ele.id);
                                              prevValue[selected].splice(
                                                index,
                                                1
                                              );
                                            }
                                            return { ...prevValue };
                                          });
                                         
                                        }}
                                        data-bs-toggle="collapse"
                                        data-bs-target={
                                          "#collapse" + selected + ele_index
                                        }
                                        aria-expanded="true"
                                        aria-controls={
                                          "collapse" + selected + ele_index
                                        }
                                      />
                                      <h6 className="ms-1">{ele.name}</h6>
                                    </label>
                                    <div className="d-flex align-items-center ">
                                      {ele.hasOwnProperty("invoiced") ? (
                                        <p className="p-2 mb-0">
                                          {ele.invoiced
                                            ? "Already Invoiced"
                                            : "Not Invoiced"}
                                        </p>
                                      ) : null}
                                      {ele.hasOwnProperty("finished") ? (
                                        <p className="p-2 mb-0">
                                          {ele.finished
                                            ? "Finished"
                                            : "Not Finished"}
                                        </p>
                                      ) : null}
                                      {ele.hasOwnProperty("gst") ? (
                                        <p className="p-2 mb-0">
                                          {ele.gst
                                            ? "With GST"
                                            : "Without GST"}
                                        </p>
                                      ) : null}
                                      {/* {ele.hasOwnProperty("") ? () : null} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                              className="p-2 px-3 accordion-collapse"
                                // id={"collapse" + selected + ele_index}
                                // className=" collapse "
                                // aria-labelledby={
                                //   "heading" + selected + ele_index
                                // }
                                // data-bs-parent={"#accordion" + selected}
                              >
                                <div className=" row">
                                  {ele.hasOwnProperty("reworks") ? (
                                    ele.reworks.map(
                                      (r_ele: any, r_index: any) => (
                                        <div className="pt-2 " key={r_index}>
                                          <label className="d-flex">
                                            {!r_ele.free ? (
                                              <input
                                                type="checkbox"
                                                name="rework"
                                                checked={
                                                  r_ele.invoiced ||
                                                  save_data.reworks.some(
                                                    (s) => s == r_ele.id
                                                  )
                                                }
                                                disabled={
                                                  r_ele.invoiced
                                                    ? true
                                                    : r_ele.finished
                                                      ? false
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  // console.log(
                                                  //   "rework e.target.checked",
                                                  //   e.target.checked
                                                  // );
                                                  SetSaveData((prevValue) => {
                                                    if (e.target.checked) {
                                                      prevValue.reworks.push(
                                                        r_ele.id
                                                      );
                                                    } else {
                                                      let index =
                                                        prevValue.reworks.findIndex(
                                                          (i) => i == r_ele.id
                                                        );
                                                      prevValue.reworks.splice(
                                                        index,
                                                        1
                                                      );
                                                    }
                                                    console.log(
                                                      "prevValue :",
                                                      prevValue
                                                    );
                                                    return { ...prevValue };
                                                  });
                                                }}
                                              />
                                            ) : null}

                                            <h6 className="ms-1">
                                              {r_ele.message} -
                                              {r_ele.free
                                                ? "(Free)"
                                                : "(Not Free)"}
                                            </h6>
                                          </label>
                                          <div className="mt-2 d-flex align-items-center">
                                            <span className="fw-bold text-dark ms-1">
                                              {r_ele.finished
                                                ? "Finished"
                                                : "Not Finished"}
                                            </span>
                                            <span className="fw-bold text-dark ms-1">
                                              {r_ele.invoiced
                                                ? "Already Invoiced"
                                                : "Not Invoiced"}
                                            </span>
                                            <span className="fw-bold text-dark ms-1">
                                              {r_ele.gst
                                                ? "With GSTt"
                                                : "Without GST"}
                                            </span>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>No reworks </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                          : null}
                      </div>
                    ) : null}
                  </div>
                  {/* <div className="my-3">
                    {selected != "" ? (
                      <div
                        className="accordion mt-3"
                        id={"accordion" + selected}
                      >
                        {Object.keys(service_data).length > 0
                          ? init_data[selected].map((ele, ele_index) => (
                              <div className="accordion-item" key={ele_index}>
                                <div
                                  className="accordion-header"
                                  id={"heading" + selected + ele_index}
                                >
                                  <div className="accordion-button ">
                                    <div className="row">
                                      <label className="d-flex">
                                        <input
                                          type="checkbox"
                                          name="service"
                                          checked={
                                            ele.invoiced ||
                                            save_data[selected].some(
                                              (s) => s == ele.id
                                            )
                                          }
                                          disabled={
                                            selected == "services"
                                              ? ele.invoiced
                                                ? true
                                                : ele.finished
                                                ? false
                                                : true
                                              : false
                                          }
                                          onChange={(e) => {
                                            SetSaveData((prevValue) => {
                                              if (e.target.checked) {
                                                prevValue[selected].push(
                                                  ele.id
                                                );
                                              } else {
                                                let index = prevValue[
                                                  selected
                                                ].findIndex((i) => i == ele.id);
                                                prevValue[selected].splice(
                                                  index,
                                                  1
                                                );
                                              }
                                              return { ...prevValue };
                                            });
                                          }}
                                        />
                                        <h6 className="ms-1">{ele.name}</h6>
                                      </label>
                                      <div className="d-flex align-items-center ">
                                        {ele.hasOwnProperty("invoiced") ? (
                                          <p className="p-2 mb-0">
                                            {ele.invoiced
                                              ? "Already Invoiced"
                                              : "Not Invoiced"}
                                          </p>
                                        ) : null}
                                        {ele.hasOwnProperty("finished") ? (
                                          <p className="p-2 mb-0">
                                            {ele.finished
                                              ? "Finished"
                                              : "Not Finished"}
                                          </p>
                                        ) : null}
                                        {ele.hasOwnProperty("gst") ? (
                                          <p className="p-2 mb-0">
                                            {ele.gst
                                              ? "With GST"
                                              : "Without GST"}
                                          </p>
                                        ) : null}
                                      </div>
                                    </div>
                                    {ele.hasOwnProperty("reworks") ? (
                                      <div
                                        className=" ms-auto cursor"
                                        data-bs-toggle="collapse"
                                        data-bs-target={
                                          "#collapse" + selected + ele_index
                                        }
                                        aria-expanded="true"
                                        aria-controls={
                                          "collapse" + selected + ele_index
                                        }
                                      >
                                        <span className="arrow-down">
                                          <i className="fas fa-chevron-down fs-7" />
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div
                                  id={"collapse" + selected + ele_index}
                                  className="accordion-collapse collapse "
                                  aria-labelledby={
                                    "heading" + selected + ele_index
                                  }
                                  data-bs-parent={"#accordion" + selected}
                                >
                                  <div className="accordion-body row">
                                    {ele.hasOwnProperty("reworks") ? (
                                      ele.reworks.map(
                                        (r_ele: any, r_index: any) => (
                                          <div className="pt-2 " key={r_index}>
                                            <label className="d-flex">
                                              {!r_ele.free ? (
                                                <input
                                                  type="checkbox"
                                                  name="rework"
                                                  checked={
                                                    r_ele.invoiced ||
                                                    save_data.reworks.some(
                                                      (s) => s == r_ele.id
                                                    )
                                                  }
                                                  disabled={
                                                    r_ele.invoiced
                                                      ? true
                                                      : r_ele.finished
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    // console.log(
                                                    //   "rework e.target.checked",
                                                    //   e.target.checked
                                                    // );
                                                    SetSaveData((prevValue) => {
                                                      if (e.target.checked) {
                                                        prevValue.reworks.push(
                                                          r_ele.id
                                                        );
                                                      } else {
                                                        let index =
                                                          prevValue.reworks.findIndex(
                                                            (i) => i == r_ele.id
                                                          );
                                                        prevValue.reworks.splice(
                                                          index,
                                                          1
                                                        );
                                                      }
                                                      console.log(
                                                        "prevValue :",
                                                        prevValue
                                                      );
                                                      return { ...prevValue };
                                                    });
                                                  }}
                                                />
                                              ) : null}

                                              <h6 className="ms-1">
                                                {r_ele.message} -
                                                {r_ele.free
                                                  ? "(Free)"
                                                  : "(Not Free)"}
                                              </h6>
                                            </label>
                                            <div className="mt-2 d-flex align-items-center">
                                              <span className="fw-bold text-dark ms-1">
                                                {r_ele.finished
                                                  ? "Finished"
                                                  : "Not Finished"}
                                              </span>
                                              <span className="fw-bold text-dark ms-1">
                                                {r_ele.invoiced
                                                  ? "Already Invoiced"
                                                  : "Not Invoiced"}
                                              </span>
                                              <span className="fw-bold text-dark ms-1">
                                                {r_ele.gst
                                                  ? "With GSTt"
                                                  : "Without GST"}
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <p>No reworks </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                          : null}
                      </div>
                    ) : null}
                  </div> */}
                </div>
              </div>
            ) : (
              <div className="g-3">
                <div className="row">
                  {props.data.items.map((i_ele: any, i_index: any) => (
                    <div>
                      {/* <p>Name : {i_ele.name}</p>
                      <p>Type : {i_ele.type}</p> */}

                      <h6>{i_ele.name}</h6>
                      <small>{i_ele.type}</small>
                      <p>{i_ele.amount}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {props.type == "add" ? (
              save_data != initial_value ? (
                <p className="v-small text-end">
                  With and Without gst can be generate
                </p>
              ) : null
            ) : null}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {props.type == "add" ? (
              save_data != initial_value ? (
                <div className="">
                  {/* <p>With and Without gst can be generate</p> */}
                  <button
                    type="button"
                    className="btn btn-light-outline"
                    onClick={() => {
                      create_invoice();
                      console.log("save :", save_data);
                    }}
                  >
                    Save
                  </button>
                </div>
              ) : null
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
